import { CloseRounded } from '@mui/icons-material';
import { Modal } from '@mui/material';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  transition: all 0.5s ease;
  padding: 20px;
  box-sizing: border-box;
`;

const Wrapper = styled.div`
  max-width: 750px;
  width: 100%;
  border-radius: 20px;
  height: max-content;
  max-height: 90vh;
  background-color: ${({ theme }) => theme.card};
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.4);
  color: ${({ theme }) => theme.text_primary};
  padding: 28px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: auto;
  
  &::-webkit-scrollbar {
      width: 6px;
  }
  &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.primary}50;
      border-radius: 10px;
  }
`;

const Title = styled.div`
  font-size: 30px;
  font-weight: 700;
  color: ${({ theme }) => theme.text_primary};
  margin: 16px 0 4px;
  @media only screen and (max-width: 600px) {
      font-size: 24px;
  }
`;

const Date = styled.div`
  font-size: 14px;
  margin-bottom: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.primary};
  @media only screen and (max-width: 768px){
      font-size: 12px;
  }
`;

const Desc = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.6;
  color: ${({ theme }) => theme.text_secondary};
  margin: 16px 0;
  @media only screen and (max-width: 600px) {
      font-size: 14px;
  }
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  max-height: 350px;
  object-fit: contain;
  border-radius: 12px;
  margin-top: 10px;
  background-color: #0b0b13;
  box-shadow: 0px 4px 15px rgba(0,0,0,0.3);
`;

const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 12px 0px;
`;

const Tag = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.primary};
  padding: 6px 12px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.primary + 15};
  border: 1px solid ${({ theme }) => theme.primary + 30};
  backdrop-filter: blur(4px);
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 24px;
  @media only screen and (max-width: 600px) {
      flex-direction: column;
      gap: 12px;
  }
`;

const Button = styled.a`
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
  padding: 12px 24px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.primary};
  ${({ noBg, theme }) => noBg && `
      background-color: transparent;
      color: ${theme.primary};
      border: 1.5px solid ${theme.primary};
  `}
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s ease;
  &:hover {
      background-color: ${({ theme }) => theme.primary}cc;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px ${({ theme }) => theme.primary}60;
      ${({ noBg, theme }) => noBg && `
          background-color: ${theme.primary}10;
          box-shadow: none;
      `}
  }
`;

const index = ({ openModal, setOpenModal }) => {
    const project = openModal?.project;
    if (!project) return null;

    return (
        <Modal open={true} onClose={() => setOpenModal({ state: false, project: null })} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Container onClick={() => setOpenModal({ state: false, project: null })}>
                <Wrapper onClick={(e) => e.stopPropagation()}>
                    <CloseRounded
                        style={{
                            position: "absolute",
                            top: "20px",
                            right: "20px",
                            cursor: "pointer",
                            color: "inherit",
                            backgroundColor: "rgba(255,255,255,0.1)",
                            borderRadius: "50%",
                            padding: "4px"
                        }}
                        onClick={() => setOpenModal({ state: false, project: null })}
                    />
                    <Image src={project?.image} alt={project?.title} />
                    <Title>{project?.title}</Title>
                    <Date>{project?.date}</Date>
                    <Tags>
                        {project?.tags?.map((tag, idx) => (
                            <Tag key={idx}>{tag}</Tag>
                        ))}
                    </Tags>
                    <Desc>{project?.description}</Desc>
                    
                    <ButtonGroup>
                        {project?.github && (
                            <Button noBg href={project.github} target="_blank">View Code</Button>
                        )}
                        {project?.webapp && (
                            <Button href={project.webapp} target="_blank">Live App</Button>
                        )}
                    </ButtonGroup>
                </Wrapper>
            </Container>
        </Modal>
    )
}

export default index;